var map = {
	"./VSIcon.png": 3887,
	"./business_icon.png": 72727,
	"./business_icon_active.png": 62930,
	"./business_pain_1.png": 29360,
	"./business_pain_2.png": 43179,
	"./business_pain_3.png": 69026,
	"./business_pain_4.png": 14397,
	"./chat_icon.png": 94059,
	"./chat_icon_active.png": 27886,
	"./combineDelivery_icon.png": 52908,
	"./combineOrder_icon.png": 15002,
	"./combinePrint_icon.png": 18721,
	"./combineSale_icon.png": 20267,
	"./copyIcon.png": 52285,
	"./core_case_1.png": 86449,
	"./core_case_2.png": 65338,
	"./ddks.png": 49439,
	"./deliveryIcon.png": 38754,
	"./dy.png": 73556,
	"./ele.png": 36905,
	"./ellipse_icon.png": 78023,
	"./evaluate_icon.png": 18162,
	"./evaluate_icon_active.png": 82065,
	"./fnps.png": 20782,
	"./jdms.png": 42847,
	"./mt.png": 23142,
	"./mtpt.png": 85930,
	"./offline_icon.png": 68430,
	"./online_icon.png": 43522,
	"./print.png": 64792,
	"./printIcon.png": 59159,
	"./sftc.png": 41237,
	"./ss.png": 50151,
	"./storeManage_icon.png": 2995,
	"./tbmc.png": 72403,
	"./tick.png": 34370,
	"./up_icon.png": 86628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56114;